import ResourceBookmark from './ResourceBookmark';

export default ResourceBookmark;
